import { Box } from '@primerai/thread';
import styled from 'styled-components';
import { BREAKPOINTS } from '~/components/theme/constants';

export const Container = styled(Box)`
  ${({ theme }) => `
    background: ${theme.colors.$background.subtleAccent};
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    height: 100%;
    min-height: 720px;
    width: 100%;

    @media screen and (max-width: ${BREAKPOINTS.SM}) {
      min-height: initial;
      grid-template-columns: 1fr;
      background-color: ${theme.colors.$background.elevation1};
    }
  `}
`;

export const PageContent = styled(Box)`
  ${({ theme }): string => `
    background: ${theme.colors.$background.elevation1};
    border-radius: 2px;
    box-shadow: ${theme.shadows.$elevation1};
    padding: ${theme.space.$10} ${theme.space.$11} ${theme.space.$9} ${theme.space.$11};
    grid-column: 2;
    grid-row: 2;
    
    @media screen and (max-width: ${BREAKPOINTS.SM}) {
      width:100%;
      padding: ${theme.space.$6};
      box-shadow: none;
      grid-column: 1;
      justify-self: center;
    }
  `}
`;
